/* eslint-disable camelcase */
import { useEffect } from 'react'

export const useRedirectToOnboarding = candidate => {
  useEffect(() => {
    if (!candidate || !candidate.id || candidate.current_state === 'onboarding') {
      // Replace with redirect once onboarding has been moved to the same bundle
      window.location.replace('/candidate/signup')
    }
  }, [candidate])
}
